import { render, staticRenderFns } from "./ActiveFilterChip.vue?vue&type=template&id=bedbcb6e&scoped=true&lang=html"
import script from "./ActiveFilterChip.vue?vue&type=script&lang=js"
export * from "./ActiveFilterChip.vue?vue&type=script&lang=js"
import style0 from "./ActiveFilterChip.vue?vue&type=style&index=0&id=bedbcb6e&prod&lang=scss&scoped=true"
import style1 from "./ActiveFilterChip.vue?vue&type=style&index=1&id=bedbcb6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedbcb6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
